function parseJsonScript(id) {
    const node = document.getElementById(id);

    if (!node) {
        return {};
    }

    try {
        return JSON.parse(node.textContent || '{}');
    } catch (error) {
        console.warn(`Unable to parse ${id}.`, error);
        return {};
    }
}

export function load() {
    window.pageData = {
        ...parseJsonScript('global-page-data'),
        ...parseJsonScript('page-data'),
    };

    return window.pageData;
}
